export const NotificationSubjectLineConstants = {
	MaximumCharacterLength: 900,
} as const

export interface NotificationSubjectLineDto {
	subjectLine: string
}
